import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type UpdateCategoryV3 = OpalApi<'UpdateCategoryV3', 200>

export const updateCategory: UpdateCategoryV3 = async (args = {}) => {
  const categoryId = args.params?.path.category_id

  if (typeof categoryId !== 'string') {
    throw new Error('Must supply a valid category_id.')
  }

  const url = new URL(
    `/loupe/v3/categories/${categoryId}`,
    window.location.origin
  )

  return HttpClient()
    .patch(url.toString(), args.requestBody)
    .then((res) => res.data)
}
